module.exports = __webpack_public_path__ + "static/media/มะแม.944e2301.jpg";